import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { RepairGroupService } from '../repair-group/repair-group.service';
import { RepairGroup } from '../repair-group/repair-group';

@Injectable({ providedIn: 'root'})
export class RepairGroupResolver implements Resolve<Observable<RepairGroup[]>>{

    constructor(private service: RepairGroupService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RepairGroup[]> {
        return this.service.findAll();
    }
}